(() => {
  const instances = new WeakMap();

  function initSection(section) {
    if (!section) return;

    destroySection(section);

    /* Product sliders */
    section.querySelectorAll(".cps-product-slider").forEach((slider) => {
      const swiper = new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 20,
        speed: 500,
        watchOverflow: true,
        observer: true,
        observeParents: true,

        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },

        pagination: {
          el: slider.querySelector(".swiper-pagination"),
          clickable: true,
        },

        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 12,
          },
          576: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          990: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1400: {
            slidesPerView: 1,
            spaceBetween: 24,
          },
        },
      });

      slider._swiper = swiper;
    });

    /* Main slider */
    const mainSlider = section.querySelector(".cps-main-slider");

    if (mainSlider) {
      const mainSwiper = new Swiper(mainSlider, {
        slidesPerView: 1,
        speed: 600,
        autoHeight: true,
        observer: true,
        observeParents: true,

        navigation: {
          nextEl: section.querySelector(".cps-main-next"),
          prevEl: section.querySelector(".cps-main-prev"),
        },
      });

      instances.set(section, mainSwiper);
    }
  }

  function destroySection(section) {
    section.querySelectorAll(".cps-product-slider").forEach((slider) => {
      if (slider._swiper) {
        slider._swiper.destroy(true, true);
        slider._swiper = null;
      }
    });

    const mainSwiper = instances.get(section);

    if (mainSwiper) {
      mainSwiper.destroy(true, true);
      instances.delete(section);
    }
  }

  function initAll() {
    document
      .querySelectorAll(".collection-product-showcase")
      .forEach((section) => {
        initSection(section);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  /* Shopify Theme Editor */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (e) => {
      if (e.target.classList.contains("collection-product-showcase")) {
        initSection(e.target);
      }
    });

    document.addEventListener("shopify:section:reorder", (e) => {
      if (e.target.classList.contains("collection-product-showcase")) {
        initSection(e.target);
      }
    });

    document.addEventListener("shopify:section:unload", (e) => {
      if (e.target.classList.contains("collection-product-showcase")) {
        destroySection(e.target);
      }
    });

    document.addEventListener("shopify:block:select", (e) => {
      const slide = e.target.closest(".cps-slide");
      if (!slide) return;

      const section = slide.closest(".collection-product-showcase");
      if (!section) return;

      const swiper = instances.get(section);
      if (!swiper) return;

      swiper.slideTo(slide.swiperSlideIndex || 0);
    });
  }
})();